import APIRequest from './APIRequest';
import IDMGlobals from './../IDMGlobals';
// API Compoenents
import APIAccessToken from './operations/APIAccessToken';
import APIApplication from './operations/APIApplication';
import APIAuthorization from './operations/APIAuthorization';
import APIExternalProvider from './operations/APIExternalProvider';
import APIPartitionACL from './operations/APIPartitionACL';
import APIPassword from './operations/APIPassword';
import APIPublicKey from './operations/APIPublicKey';
import APIRegistration from './operations/APIRegistration';
import APIRegistrationConfirmation from './operations/APIRegistrationConfirmation';
import APIRole from './operations/APIRole';
import APIUser from './operations/APIUser';
import APIUserPartition from './operations/APIUserPartition';
import APIUserPartitionFile from './operations/APIUserPartitionFile';

export default class API {

  /**
   * constructor - description
   *
   * @param  {type} datasource description
   * @return {type}            description
   */
  constructor(datasource) {
    this.datasource = datasource;
    //api operations
    this.accessToken = new APIAccessToken(this);
    this.application = new APIApplication(this);
    this.authorization = new APIAuthorization(this);
    this.partitionACL = new APIPartitionACL(this);
    this.password = new APIPassword(this);
    this.registration = new APIRegistration(this);
    this.registrationConfirmation = new APIRegistrationConfirmation(this);
    this.role = new APIRole(this);
    this.user = new APIUser(this);
    this.userPartition = new APIUserPartition(this);
    this.publicKey = new APIPublicKey(this);
    this.externalProvider = new APIExternalProvider(this);
    this.userPartitionFile = new APIUserPartitionFile(this);
  }

  /**
   * async newBaseRequest - description
   */
  async newBaseRequest(method, allowsAppImpersonation, isRenewalCall, optionalOverrideAppID) {
    const req = this.newPlainRequest(method);
    //Check for authorization token
    const token = await this.datasource.session.getToken(!isRenewalCall);
    if (token) req.appendHeader('Authorization', 'Bearer ' + token);
    //Append app auth token
    const appID = optionalOverrideAppID || ((await this.datasource.currentAppIDHash(allowsAppImpersonation)));
    req.appendQueryParam(IDMGlobals.URLQueryParam_AppIDv2, appID);
    //Check if logged and have resources token
    if (this.datasource.isLogged()) {
      const resourcesToken = await this.datasource.session.data.getResourcesToken();
      if (resourcesToken) req.appendHeader('ResourcesToken', resourcesToken);
    }
    //
    return req;
  }
  /**
  * newPlainRequest - description
  *
  * @param  {type} method                    description
  * @return {type}                           description
  */
  newPlainRequest(method) {
    const req = new APIRequest(method);
    //Base url
    req.baseURL = this.datasource.opts.apiEndpoint;
    //
    return req;
  }
}
